<script setup lang="ts">
import Game from '@/components/Game.vue'
import { onMounted, onUnmounted } from 'vue'
import Backend from '@/models/backend'

let pingIntervalId: number | undefined

// Mobile viewport height fix for keyboards
onMounted(() => {
  // Set CSS variable with real viewport height
  const setVh = () => {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }

  // Set on initial load
  setVh()

  // Update on resize
  window.addEventListener('resize', setVh)

  // Set up ping interval to keep session alive
  const backend = new Backend()
  pingIntervalId = window.setInterval(() => {
    backend.ping()
  }, 60 * 1000) // 1 minute in milliseconds

  // Clean up
  onUnmounted(() => {
    window.removeEventListener('resize', setVh)
    if (pingIntervalId !== undefined) {
      clearInterval(pingIntervalId)
    }
  })
})
</script>

<template>
  <main>
    <Game />
  </main>
</template>

<style>
body {
  user-select: none !important;
  background-color: black; /* matches status bar */
}

/* iOS-specific safe area insets - only apply on iOS devices to avoid Android issues */
@supports (-webkit-touch-callout: none) {
  body {
    padding-top: env(safe-area-inset-top); /* space for status bar */
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
    /* padding-bottom removed - was pushing up footer on iPad */
  }
}

html,
body {
  /* don't allow pulldown refresh on mobile */
  overscroll-behavior-y: contain;
}

/* Use custom viewport height variable that updates with keyboard */
.content-height-limit {
  height: calc((var(--vh, 1vh) * 100) - 5.5rem - var(--chat-height)) !important;
}

@media (max-width: 768px) {
  .content-height-limit {
    height: auto !important;
    min-height: 300px !important;
    max-height: calc((var(--vh, 1vh) * 100) - 5.5rem - var(--chat-height)) !important;
  }
}
</style>
